/** @import { FC } from 'react' */
import { useEffect } from 'react';
import PinContent from './PinContent';
import { List } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '@plone/volto/actions';
import jwtDecode from 'jwt-decode';
import ToggleBookmarkActions from './ToggleBookmarkActions';

const ContentActions = () => {
  const dispatch = useDispatch();
  const userId = useSelector((state) =>
    state.userSession.token ? jwtDecode(state.userSession.token).sub : '',
  );
  const user = useSelector((state) => state.users?.user || {});

  useEffect(() => {
    dispatch(getUser(userId));
  }, [dispatch, userId]);

  return (
    <List className={'content-actions'}>
      <List.Item>
        <ToggleBookmarkActions />
      </List.Item>
      <List.Item>
        <PinContent user={user} />
      </List.Item>
    </List>
  );
};

export default ContentActions;
